import ConvenioModel from "../models/convenioModel";
import nfetch from "../utils/events/nfetch";

import { IService } from "./base/iService";
export default class ConvenioService extends IService<ConvenioModel> {
    constructor() {
        super("Convenio");
    }

    public getFromCliente(clienteId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFromCliente?clienteId=${clienteId}`, {
            credentials: "same-origin",
        });
    }

    public getFromPrescritor(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/getFromPrescritor?id=${id}`, {
            credentials: "same-origin",
        });
    }
}
